import React from "react";
import { Card, Col, Row, Grid } from "antd";
import { Chart, Axis, Geom, Tooltip, Legend } from "bizcharts";
import { inRange } from "lodash";
import moment from "moment";
import DataSet from "@antv/data-set";
//Global Styles
import {
  CardTitleText,
  CardText,
  KPITitleText,
  KpiSubText,
} from "../../../../../../shared/globalStyling/styledText";
import { ExtraInfo } from "./";

import { formatWholeNumber } from "../../../../../../../core/utils/campaigns";

const TotalVisitsChart = ({ totalAndUniqueVisitsData }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const ds = new DataSet().createView().source(
    totalAndUniqueVisitsData.map(el => {
      const { COUNT, UNIQUE, ...rest } = el;
      return {
        Visits: COUNT,
        Unique: UNIQUE ? UNIQUE : 0,
        ...rest,
      };
    })
  );
  ds.transform({
    type: "fold",
    fields: ["Visits", "Unique"],
    retains: ["CONVERSIONDATE"],
    key: "type",
    value: "numOfVisits",
  });
  // Set a tivkInterval that will not display more than 10 Y axis intervals at any given time.
  const getTickInterval = data => {
    let range = 0;
    let interval = 1;
    // Find the highest number of visits
    let max = data.reduce((a, c) => {
      return Math.max(a, c.numOfVisits);
    }, 0);
    while (!inRange(max, range, range + 10)) {
      range += 10;
      interval++;
    }
    return interval;
  };

  const scale = {
    numOfVisits: {
      tickInterval: getTickInterval(ds.rows),
      min: 0,
    },
  };

  return (
    <Chart
      data={ds}
      scale={scale}
      height={screens.xs === true ? 300 : 200}
      padding="auto"
      onTooltipChange={ev => {
        let items = ev.items;
        const originTotal = items[0];
        const originUnique = items[1];
        items.splice(0);
        items.push({
          name: "Total Visits",
          size: originTotal.size,
          showMarker: originTotal.showMarker,
          title: moment(originTotal.title).format("MMM Do YYYY"),
          marker: originTotal.marker,
          color: originTotal.color,
          value: formatWholeNumber(originTotal.value),
          x: originTotal.x,
          y: originTotal.y,
          point: originTotal.point,
        });
        if (originUnique) {
          items.push({
            name: "Unique Visits",
            size: originUnique.size,
            showMarker: originUnique.showMarker,
            title: moment(originUnique.title).format("MMM Do YYYY"),
            marker: originUnique.marker,
            color: originUnique.color,
            value: formatWholeNumber(originUnique.value),
            x: originUnique.x,
            y: originUnique.y,
            point: originUnique.point,
          });
        }
      }}
    >
      <Legend
        position="top-center"
        itemFormatter={val => {
          if (val === "Visits") return "Total Visits";
          if (val === "Unique") return "Unique Visits";
        }}
      />
      <Tooltip />
      <Axis
        name="CONVERSIONDATE"
        label={{
          formatter(text) {
            return moment(text).format("MMM DD");
          },
        }}
      />
      <Axis
        name="numOfVisits"
        label={{
          formatter(text) {
            return formatWholeNumber(text);
          },
        }}
      />
      <Geom
        type="line"
        position="CONVERSIONDATE*numOfVisits"
        color={[
          "type",
          type => {
            if (type === "Visits") return "#0077fe";
            else return "#ff0000";
          },
        ]}
        size={1}
        shape={"smooth"}
      />
    </Chart>
  );
};
const TotalVisitsChartCard = ({
  uniqueResponses,
  totalVisits,
  totalAndUniqueVisitsData,
  flightDates,
}) => {
  return (
    <Card
      title={<CardTitleText text={"Visits: New And Returning Over Time"} />}
      style={{ minHeight: "22em" }}
      bodyStyle={{ padding: 0 }}
      headStyle={{ borderWidth: "2px" }}
      extra={
        <ExtraInfo
          placement={"topLeft"}
          title={
            "This chart shows a comparison of the total and unique visits over the life of the campaign dates."
          }
        />
      }
    >
      <Row>
        <Col xs={24} md={8} lg={8} xl={8} style={{ padding: "3%" }}>
          <Row>
            <Col xs={24}>
              <KPITitleText text={"Total Walk-ins"} />
              <div style={{ marginTop: "1%" }}>
                <KpiSubText text={`${formatWholeNumber(totalVisits)}`} />
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "5%" }}>
            <Col xs={24}>
              <KPITitleText text={"Unique Walk-ins"} />
              <div style={{ marginTop: "1%" }}>
                <KpiSubText text={`${formatWholeNumber(uniqueResponses)}`} />
              </div>
            </Col>
          </Row>
        </Col>
        <Col
          style={{
            padding: "2%",
            borderLeft: "solid 1px #e8e8e8",
            minHeight: "17.75em",
            overflow: "auto",
          }}
          xs={24}
          md={15}
          lg={15}
          xl={15}
        >
          <Row type="flex" justify="center">
            <CardText
              text={`${flightDates.start} - ${flightDates.end} (+ 30 days)`}
            />
          </Row>
          {totalAndUniqueVisitsData && (
            <TotalVisitsChart
              totalAndUniqueVisitsData={totalAndUniqueVisitsData}
            />
          )}
        </Col>
      </Row>
    </Card>
  );
};

export { TotalVisitsChartCard };
